<template>
  <div>
    <!-- hr icono help -->
    <v-row align="center">
      <v-col class="flex-grow-0 flex-shrink-0">
        <!-- TODO: traducir -->
        <strong :class="color + '--text text--darken-3'">{{ subtitle }}</strong>
      </v-col>
      <v-col class="flex-grow-1 flex-shrink-0">
        <v-divider></v-divider>
      </v-col>
      <v-col class="flex-grow-0 flex-shrink-1">
        <v-btn icon @click="showHelp = !showHelp">
          <v-icon :color="color + ' darken-3'">help</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- help -->
    <v-slide-y-transition>
      <v-container class="pa-0" v-show="showHelp">
        <v-row class="ma-0">
          <v-col
            :class="color"
            class="pa-4 mb-2 lighten-3"
            v-html="help"
          ></v-col>
        </v-row>
      </v-container>
    </v-slide-y-transition>
  </div>
</template>

<script>
export default {
  name: "mdd-paso-subtitulo",
  props: ["subtitle", "help", "userColor"],
  data: () => {
    return {
      showHelp: false
    };
  },
  computed: {
    color() {
      // eslint-disable-next-line prettier/prettier
      return this.userColor == ""
        ? "primary"
        : this.userColor;
    }
  }
};
</script>
